import React, { useCallback, useState } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/standard-button';
import QuestionIcon from '@atlaskit/icon/glyph/question';
import { IssueTypesAddModal } from '@atlassian/jira-admin-pages-issue-types-add-modal/src/async.tsx';
import { useIssueTypesActions } from '@atlassian/jira-admin-pages-issue-types-resources/src/controllers/issue-types/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useRouter } from '@atlassian/react-resource-router';
import { messages } from './messages';

export const HeaderActions = () => {
	const { formatMessage } = useIntl();

	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [, { fetchIssueTypes }] = useIssueTypesActions();

	const openAddModal = useCallback(
		// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
		(_, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'button clicked', 'addIssueType');
			return setIsAddModalOpen(true);
		},
		[setIsAddModalOpen],
	);

	// eslint-disable-next-line jira/router/no-useRouter-in-components
	const [routerState] = useRouter();

	const closeAddModal = useCallback(
		(success: boolean) => {
			setIsAddModalOpen(false);
			if (success) fetchIssueTypes(routerState.location.search);
		},
		[fetchIssueTypes, routerState.location.search],
	);

	return (
		<>
			<ButtonGroup>
				<Button
					appearance="primary"
					onClick={openAddModal}
					isDisabled={isAddModalOpen}
					testId="admin-pages-issue-types-directory.ui.header-actions.add-issue-type-button"
				>
					{formatMessage(messages.addIssueType)}
				</Button>
				<Button
					appearance="subtle-link"
					href="https://support.atlassian.com/jira-cloud-administration/docs/add-edit-and-delete-an-issue-type/"
					target="_blank"
					iconBefore={<QuestionIcon label="Learn more" />}
				/>
			</ButtonGroup>

			<IssueTypesAddModal isOpen={isAddModalOpen} onClose={closeAddModal} />
		</>
	);
};
